var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEligibilityDashedLineMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 118,
    viewBox: "0 0 375 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M806.768 108.035C780.684 91.3077 715.568 54.0701 653.689 54.5679C573.958 55.2649 524.011 86.0307 468.514 88.9181C434.568 90.7103 444.835 93.0999 392.205 89.0177C334.766 84.5372 322.094 84.9355 296.38 66.7149C275.106 51.5809 280.101 19.4212 291.663 10.3607C303.225 1.20062 318.949 -0.890258 330.511 6.37805C347.623 17.0316 349.565 34.2565 349.75 48.7931C349.842 58.3514 346.235 82.2472 330.973 91.1086C318.302 98.576 310.532 98.3769 296.935 98.2773C273.349 97.9786 203.7 65.6197 170.957 57.1566C138.214 48.6935 113.24 45.8061 86.879 47.4987C47.1986 50.0874 7.98066 61.0397 -36.047 77.7667C-80.0746 94.4938 -154.811 99.9699 -193.289 98.9743C-252.485 97.4808 -349.79 68.4076 -423.971 51.6805C-497.412 35.1526 -577.883 40.2304 -647.902 53.4727C-718.476 66.8145 -775.083 85.732 -827.712 93.7968C-874.237 100.866 -919.19 103.654 -945.366 104.45",
    stroke: "#CCEDEC",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "10.04 10.04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEligibilityDashedLineMobile);
export default __webpack_public_path__ + "static/media/eligibility-dashed-line-mobile.45aa182aaf0a0c9c88268a34cadd639d.svg";
export { ForwardRef as ReactComponent };